import { JwtAxios } from '@/packaging';
export const kakaoShoppingApi = {
  async GetKakaoShoppingApiTemplate(marketAccount) {
    const responseModel = await JwtAxios.get(
      `/Template/Market/GetKakaoShoppingApiTemplate?marketAccount=${marketAccount}`
    );
    return responseModel;
  },
  async SetKakaoShoppingApiTemplate(model) {
    const responseModel = await JwtAxios.post(`/Template/Market/SetKakaoShoppingApiTemplate`, model);
    return responseModel;
  },
  async SetKakaoShoppingApi(body) {
    const responseModel = await JwtAxios.post('/Template/Market/SetKakaoShoppingApi', body);
    return responseModel;
  },
  async GetKakaoShoppingAddresses(marketAccount) {
    const responseModel = await JwtAxios.get(
      `/Template/Market/GetKakaoShoppingAddresses?marketAccount=${marketAccount}`
    );
    return responseModel;
  }
};
